import React, {useEffect, useState} from "react";
import {useOutletContext} from "react-router";
import {useMediaQuery} from "@mui/material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import {WinsPoolResultsGrid} from "../components/grids/WinsPoolResultsGrid";
import {WinsPoolChart} from "../components/WinsPoolChart";
import {SeasonPicker} from "../components/pickers/SeasonPicker";
import {apiGet} from "../utils";

export const WinsPoolContainer = () => {
    const {currentAuction} = useOutletContext();
    const [seasonYears, setSeasonYears] = useState([]);
    const [selectedSeasonYear, setSelectedSeasonYear] = useState(null);
    const [scoreboard, setScoreboard] = useState([]);
    const [results, setResults] = useState([]);
    const [showChart, setShowChart] = useState(false);
    const [loading, setLoading] = useState(true);

    const isMobile = useMediaQuery('(max-width: 1275px)');

    const fetchWinsSeasonYears = () => {
        setLoading(true);
        apiGet(`wins/seasons`, (data) => {
            setSeasonYears(data.data ? data.data.map(s => s.year) : []);
            setLoading(false);
        });
    };

    const fetchWinsPoolScoreboard = (season) => {
        if (season) {
            setLoading(true);
            apiGet(`wins/scoreboard/season/${season}`, (data) => {
                console.log(`data: ${JSON.stringify(data, null, 2)}`);
                setScoreboard(data.data ? data.data : []);
                setLoading(false);
            });
        }
    };

    const fetchWinsPoolResults = (season) => {
        if (season) {
            setLoading(true);
            apiGet(`wins/results/season/${season}`, (data) => {
                console.log(`data: ${JSON.stringify(data, null, 2)}`);
                setResults(data.data ? data.data : []);
                setLoading(false);
            });
        }
    };

    useEffect(() => {
        fetchWinsSeasonYears();
        setSelectedSeasonYear(currentAuction.season_year);
    }, [currentAuction]);

    useEffect(() => {
        fetchWinsPoolScoreboard(selectedSeasonYear);
        fetchWinsPoolResults(selectedSeasonYear);
    }, [selectedSeasonYear]);

    const setYear = (year) => {
        setSelectedSeasonYear(year);
    };

    const handleClickShowChart = () => {
        setShowChart(true);
    };

    const justify = isMobile ? 'flex-start' : 'center';
    return (
        <Grid container justifyContent={justify}>
            <table>
                <tbody>
                <tr>
                    <td>
                        <div style={{textAlign: "center"}}>
                            <div style={{textAlign: "right", marginBottom: 15}}>
                                {/*TODO: set includeCurrent to true when there is data for this season... */}
                                <SeasonPicker setterFunction={setYear} seasonYearsOverride={seasonYears} includeCurrent={false}/>
                            </div>
                            {loading && <LinearProgress color="secondary"/>}
                            <WinsPoolResultsGrid scoreboard={scoreboard} results={results} loading={loading}/>
                            <br/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style={{textAlign: "center"}}>
                            {!showChart &&
                                <Button
                                    style={{backgroundColor: "lightgray", height: 25, marginLeft: 10, marginRight: 10}}
                                    onClick={handleClickShowChart}>Show Chart</Button>
                            }
                            {showChart &&
                                <div style={{marginBottom: 50, marginLeft: 0, marginRight: 0}}>
                                    <WinsPoolChart picks={scoreboard} gameResults={results}/>
                                </div>
                            }
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </Grid>
    );
}